import momentTZ from "moment-timezone";
import { DEFAULT_TIMEZONE } from "../../constants";
import React, { useEffect, useState } from "react";
import { getEmailNotifications } from "../../services/email";

import { displayDateTime } from "../../utils/dateDisplay";
export default function EmailNotificationQueue() {
  const [emailNotifications, setEmailNotifications] = useState([]);
  useEffect(() => {
    getEmailNotifications(momentTZ().tz(DEFAULT_TIMEZONE).endOf("day").unix()).then((data) =>
      setEmailNotifications(data)
    );
  }, []);
  return (
    <>
      <p className="menu-label">
        Email Queue for {momentTZ().tz(DEFAULT_TIMEZONE).format("YYYY-MM-DD")}: {emailNotifications.length}
      </p>
      <table className="table is-hoverable is-narrow is-size-7">
        <thead>
          <tr>
            <td>CLIENT APPOINTMENT ID</td>
            <td>WHO</td>
            <td>WHEN</td>
          </tr>
        </thead>
        <tbody>
          {emailNotifications.map((rowData, idx) => (
            <tr key={idx}>
              <td>{rowData.client_appointment_id}</td>
              <td>{rowData.who}</td>
              <td>{displayDateTime(rowData.when, "YYYY-MM-DD h:mmA")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
